/**
 * Cashflow Cockpit — data source.
 *
 * Calls the live recon API (GET /v1/api/recon/master) through the shared axios
 * service (which injects the Bearer token), then maps the verbose API shape to
 * the compact view model via apiMapper. Falls back to the bundled placeholder
 * only if explicitly forced or the call fails in development.
 *
 * Endpoints (read-only, auth('recon')):
 *   GET /recon/master           — full dataset (summary + 650 invoice records)
 *   GET /recon/status           — cash-position rollup
 *   GET /recon/audits?min_high  — forensic verdicts
 */

import type { ApiResponse } from '../../services/api';
import { apiService } from '../../services/api';
import { mapCockpitData } from './apiMapper';
import type { CockpitData } from './types';
import mock from './mockCockpitData.json';

/** Set true to render the bundled placeholder instead of calling the API. */
export const USE_MOCK_COCKPIT_DATA = false;

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
type ReconMasterResponse = any;

export const getCockpitData = async (): Promise<CockpitData> => {
	if (USE_MOCK_COCKPIT_DATA) {
		await new Promise(resolve => setTimeout(resolve, 150));
		return mock as unknown as CockpitData;
	}

	const res = await apiService.get<ReconMasterResponse>('/recon/master');
	const payload = (res as ApiResponse<ReconMasterResponse>).data ?? res;
	return mapCockpitData(payload);
};
